import styled from "styled-components";

export const Container = styled.div`
  height: 40%;
  background-color: #2a2a2a;
  width: 100%;
  overflow-x: hidden;
  padding: 0;
  color: var(--text);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  height: 88vh;
  &.collapsed {
    height: 45px;
    position: sticky;
    top: 0;
    left: 0;
    padding: 1.3rem 0.5rem;
  }
  .sidebar-top {
    position: absolute;
    bottom: 12%;
    right: 5%;
  }
  .collapsed .sidebar-top {
    display: flex;
    flex-direction: column;
    padding: 0px;
    justify-content: center;
  }
  .expand-btn {
    position: relative;
    display: grid;
    place-items: center;
    border-radius: 6px;
    cursor: pointer;
    transition: 0.3s;
  }
  .expand-btn svg {
    stroke: white;
    transform: rotate(90deg);
    width: 42px;
    height: 42px;
  }
  &.collapsed .expand-btn svg {
    margin-top: 4px;
    transform: rotate(270deg);
    width: 48px;
    height: 48px;
  }
  &.collapsed .side-video-container {
    display: none;
  }
  .side-video-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 50%;
    margin: auto;
    background-color: #2a2a2a;
    transform: rotate(90deg);
    input {
      color: white;
      width: 100%;
      font-size: 100%;
    }
  }
  video {
    width: 100%;
    height: 100%;
    background-color: #2a2a2a;
  }
  @media only screen and (min-width: 867px) {
    height: 100%;
    padding: 0;
    position: sticky;
    top: 0;
    left: 0;
    &.collapsed {
      height: 100%;
      width: 80px;
      position: sticky;
      top: 0;
      left: 0;
      padding: 0;
    }
    .side-video-container {
      transform: rotate(0deg);
      height: 70%;
      width: 100%;
      margin-top: 0;
      input {
        width: 100%;
        font-size: 100%;
      }
    }
    .sidebar-top {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
      margin-bottom: 32px;
      top: 0;
      width: 100%;
      right: 0;
    }
    .expand-btn svg {
      transform: rotate(0deg);
    }
    &.collapsed .expand-btn svg {
      transform: rotate(180deg);
    }
  }
`;
